import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useTypedApiClient } from 'hooks/useTypedApiClient'

interface SweepstakeWinnersMessageData {
  sweepstakeWinnerIds: number[]
}

interface usePostLocationSweepstakeWinnerMessageProps {
  onSuccess?: () => void
  onError?: () => void
}

export const usePostLocationSweepstakeWinnerMessage = ({
  onSuccess,
  onError,
}: usePostLocationSweepstakeWinnerMessageProps) => {
  const queryClient = useQueryClient()

  const postSweepstakeWinnerMessage = useTypedApiClient({
    path: '/le-connect/sweepstake-winners/message',
    method: 'post',
  })

  return useMutation({
    mutationFn: async (request: SweepstakeWinnersMessageData) => {
      const { data } = await postSweepstakeWinnerMessage(request)
      return data
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ['/sweepstakes'],
      })
      await queryClient.invalidateQueries({
        queryKey: ['/sweepstakes/drawing-info/multi-draw'],
      })
      onSuccess?.()
    },
    onError,
  })
}
